module.exports = __webpack_public_path__ + "static/media/car15.d072354d.png";